import { Box } from "@mui/material"
import { ScheduleActions } from "../schedulePage/ScheduleActions";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { derivState } from "../../../redux/deriv/derivSlice";
import { loadEventDerivs } from "../../../redux/deriv/derivActions";
import { ScheduleCommonRefresh } from "../scheduleCommon/ScheduleCommonRefresh";
import { autoRefreshTopics } from "../../shared/commonConstants";

interface ScheduleDerivsActionsRightProps {
    eventId?: number;
}

export const ScheduleDerivsActionsRight = ({
    eventId
}: ScheduleDerivsActionsRightProps) => {

    const dispatch = useAppDispatch();
    const deriv = useAppSelector(derivState);

    const handleRefresh = () => {
        if (eventId) {
            dispatch(loadEventDerivs(eventId, true));
        }
    };

    return (
        <Box sx={{ margin: "-19px -10px 0 0", display: "flex", alignItems: "center" }}>
            <ScheduleActions />
            {eventId && (
                <ScheduleCommonRefresh
                    eventId={eventId}
                    topic={autoRefreshTopics.derivMarket}
                    desc="derivative"
                    loading={deriv.reloading}
                    onRefresh={handleRefresh}
                />
            )}
        </Box>
    )
}
